import React, { useState } from 'react';
import { AiOutlineEye, AiOutlineEyeInvisible, AiOutlineUser } from 'react-icons/ai';
import { BiLockAlt } from 'react-icons/bi';
import styles from './styles.module.css';
import cn from 'classnames';

export default function Input({ type = 'text', name, ...props }) {
  const [showPassword, setShowPassword] = useState(false);
  const isPassword = type === 'password';
  const inputType = isPassword && showPassword ? 'text' : type;

  const handleToggle = () => setShowPassword((prev) => !prev);

  return (
    <div className={styles.wrapper}>
      {/* Иконка слева */}
      {isPassword ? (
        <BiLockAlt className={styles.icon} />
      ) : (
        <AiOutlineUser className={styles.icon} />
      )}

      {/* Поле ввода */}
      <input {...props} name={name} type={inputType} />

      {/* Иконка-глаз справа */}
      {isPassword && (
        <span
          className={cn(styles.icon, styles.showIcon, showPassword && styles.active)}
          onClick={handleToggle}
          role="button"
          aria-label="Показать или скрыть пароль"
        >
          {showPassword ? <AiOutlineEyeInvisible /> : <AiOutlineEye />}
        </span>
      )}
    </div>
  );
}
